import orderQueries from '@apis/queries/orderQueries';
import { useQuery } from '@tanstack/react-query';

function useOrderReceipt(orderId: string) {
    const { data: receipt, isFetching } = useQuery(orderQueries.receipt(orderId));
    return {
        receipt, isFetching,
    };
}

export default useOrderReceipt;
